import { useAppStore } from '../state/store';
import { IconSwap } from './Icons';
import { PlaceInput } from './PlaceInput';

/**
 * Scheda partenza/arrivo con la «rotaia» di Google Maps: cerchio per
 * l'origine, linea punteggiata, pin rosso per la destinazione.
 */
export function SearchCard() {
  const a = useAppStore((s) => s.a);
  const b = useAppStore((s) => s.b);
  const swap = useAppStore((s) => s.swap);

  return (
    <div className="search">
      <div className="search__rail" aria-hidden="true">
        <span className="glyph-origin" />
        <span className="rail-line" />
        <span className="glyph-dest">
          <svg viewBox="0 0 32 44" width="14" height="19">
            <path
              d="M16 1.5C8 1.5 1.5 8 1.5 16c0 10.2 14.5 26.5 14.5 26.5S30.5 26.2 30.5 16C30.5 8 24 1.5 16 1.5z"
              fill="#EA4335"
            />
            <circle cx="16" cy="16" r="5.5" fill="#8b1d12" />
          </svg>
        </span>
      </div>
      <div className="search__fields">
        <PlaceInput which="a" />
        <div className="hairline" />
        <PlaceInput which="b" />
      </div>
      <button
        type="button"
        className="icon-btn search__swap"
        aria-label="Scambia partenza e arrivo"
        title="Scambia partenza e arrivo"
        onClick={swap}
        disabled={!a && !b}
      >
        <IconSwap size={18} />
      </button>
    </div>
  );
}
